import React, {useCallback, useState} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import Indentation from '../../../../components/Simple/Indentation';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import SMCButton from '../../../../components/Simple/SMCButton';
import RowLayout from '../../../../components/Layouts/RowLayout';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';

const pageSchema = GatewayGetSchema.pages.dynamicDns;
const pageId = pageSchema.pageId;

function GatewayDynamicDns({
    gatewayObject,
    setGatewayData
}) {
    const { t } = useTranslation();

    const setPageData = useCallback((paramName, newValue) => {
        setGatewayData([pageId, paramName], newValue);
    }, [setGatewayData]);
    
    const pageData = gatewayObject[pageId];
    const primaryDomainName = pageData[pageSchema.primaryDomainName];
    const dnsAliasList      = pageData[pageSchema.dnsAliasList];
    
    const [selectedAliases, setSelectedAliases] = useState([]);

    const handleNewDnsAlias = useCallback(() => {
        setPageData(pageSchema.dnsAliasList, [...dnsAliasList, '']);
    }, [setPageData, dnsAliasList]);

    const handleDeleteSelectedDnsAlias = useCallback(() => {
        setPageData(pageSchema.dnsAliasList, dnsAliasList.filter((val, i) => !selectedAliases.includes(i)));
        setSelectedAliases([]);
    }, [setPageData, dnsAliasList, selectedAliases]);

    return (
        <EditorLayout>
            <SMCLabel bold>{t('SMP.GATEWAYS.PAGE.SERVICES.DYNAMIC_DNS_SETTINGS')}</SMCLabel>
            <Indentation>
                <SMCTextInput readOnly value={primaryDomainName} label={t('SMP.GATEWAYS.PAGE.SERVICES.PRIMARY_DOMAIN_NAME')} />
            </Indentation>
            <SMCLabel bold>{t('SMP.GATEWAYS.PAGE.SERVICES.DNS_ALIASES')}</SMCLabel>
            <Indentation>
                <RowLayout>
                    <SMCButton icon="new" variant="ghost" onClick={handleNewDnsAlias}>{t('SMC_GEN_NEW')}</SMCButton>
                    <SMCButton icon="delete" variant="ghost" onClick={handleDeleteSelectedDnsAlias} disabled={selectedAliases.length === 0}>{t('SMC_GEN_DELETE')}</SMCButton>
                </RowLayout>
                {
                    dnsAliasList && dnsAliasList.map((alias, index) => (
                        <RowLayout spacing="4px" key={index}>
                            <SMCLabel bold inline>{index+1}</SMCLabel>
                            <SMCCheckbox
                                inline
                                checked={selectedAliases.includes(index)}
                                onChange={e => {
                                    if (e.target.checked) {
                                        setSelectedAliases([...selectedAliases, index]);
                                    }
                                    else {
                                        setSelectedAliases(selectedAliases.filter(val => val !== index));
                                    }
                                }}
                            />
                            <SMCTextInput
                                inline
                                value={alias}
                                onChange={e => {
                                    const updatedDnsAliasList = [...dnsAliasList];
                                    updatedDnsAliasList[index] = e.target.value;
                                    setPageData(pageSchema.dnsAliasList, updatedDnsAliasList);    
                                }}
                            />
                        </RowLayout>
                    ))
                }
            </Indentation>
        </EditorLayout>
    );
}

export default GatewayDynamicDns;